import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'merchant_eval_dialog',
  props: {
    currentMerchant: {
      type: Object
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '评价',
        addFunName: 'logisticHongdeMerchantEvalAdd'
      },
      formData: {
        merchantId: this.currentMerchant.merchantId,
        userId: this.currentMerchant.merchantUserId,
        userNickname: null,
        headImage: null,
        evalContent: null,
        evalScore: null
      },
      rules: {
        evalContent: [{
          required: true,
          message: '评价内容不能为空',
          trigger: 'blur'
        }],
        evalScore: [{
          required: true,
          message: '评分不能为空',
          trigger: 'blur'
        }],
        headImage: [{
          required: true,
          message: '头像不能为空',
          trigger: 'blur'
        }],
        userNickname: [{
          required: true,
          message: '评价人不能为空',
          trigger: 'blur'
        }]
      },
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    submitFormData: function submitFormData() {
      var _this = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this.$api[_this.pageConfig.addFunName](_this.saveFormDataProcess(_this.formData)).then(function (res) {
            if (res.data) {
              _this.$message.success('新增成功');
              _this.initFormData(_this.emptyFormData);
              _this.add(true);
            } else {
              _this.$message.error('新增失败');
            }
          });
        }
      });
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add(data) {
      this.$emit('close', data);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadHeadImage: function uploadHeadImage(_ref) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.formData.headImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeHeadImageFrontFile: function removeHeadImageFrontFile() {
      this.formData.headImage = '';
    },
    previewFile: function previewFile(path) {
      window.open(path);
    }
  }
};